import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numberArrayGenerator from 'number-array-generator';
import Helmet from 'react-helmet';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router';
import AutoComplete from 'material-ui/AutoComplete';
import Paper from 'material-ui/Paper';
import AdBlockDetect from 'react-ad-block-detect';
import cookie from 'js-cookie';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { generateFacebookTargetingSpec } from '../../../helpers/facebookAdTargeting';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import DropDownMenu from 'material-ui/DropDownMenu';
import TextField from 'material-ui/TextField';
import { Accordion, AdStep2Preview, ButtonBar, FormSection, PageHeader, MultiAccordionSection, SecondaryButton } from 'components';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import RaisedButton from 'material-ui/RaisedButton';
import { initLeadAdBuilder, setLeadAdBuilderBullet, setLeadAdQuestion, addLeadFormCustomQuestion, removeLeadFormCustomQuestion, setLeadFormCustomQuestion, addLeadFormMultipleChoiceAnswer, removeLeadFormMultipleChoiceAnswer, setAppointmentConfirmationEnabled, setAppointmentConfirmationText } from 'redux/modules/adBuilder';
import Checkbox from 'material-ui/Checkbox';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import ShortAnswerQuestion from './ShortAnswerQuestion';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';
import AppointmentScheduling from './AppointmentScheduling';
import * as styles from './style.scss';
var Questions = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    formValues: state.form["adForm_".concat(orgId)] ? state.form["adForm_".concat(orgId)].values : {},
    theme: state.theme
  };
}, {
  initLeadAdBuilder: initLeadAdBuilder,
  setLeadAdBuilderBullet: setLeadAdBuilderBullet,
  setLeadAdQuestion: setLeadAdQuestion,
  addLeadFormCustomQuestion: addLeadFormCustomQuestion,
  removeLeadFormCustomQuestion: removeLeadFormCustomQuestion,
  setLeadFormCustomQuestion: setLeadFormCustomQuestion,
  addLeadFormMultipleChoiceAnswer: addLeadFormMultipleChoiceAnswer,
  removeLeadFormMultipleChoiceAnswer: removeLeadFormMultipleChoiceAnswer,
  setAppointmentConfirmationEnabled: setAppointmentConfirmationEnabled,
  setAppointmentConfirmationText: setAppointmentConfirmationText
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Questions, _Component);

  var _super = _createSuper(Questions);

  function Questions(props) {
    var _this;

    _classCallCheck(this, Questions);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "informationTypes", function () {
      return [{
        title: 'User Information',
        fields: [{
          title: 'Email',
          key: 'email'
        }, {
          title: 'Full name',
          key: 'full_name',
          disabled: !!_this.props.builder.infoQuestions.find(function (val) {
            return val === 'first_name' || val === 'last_name';
          })
        }]
      }, {
        title: 'Contact Fields',
        fields: [{
          title: 'First name',
          key: 'first_name',
          disabled: !!_this.props.builder.infoQuestions.find(function (val) {
            return val === 'full_name';
          })
        }, {
          title: 'Last name',
          key: 'last_name',
          disabled: !!_this.props.builder.infoQuestions.find(function (val) {
            return val === 'full_name';
          })
        }, {
          title: 'Phone number',
          key: 'phone'
        }, {
          title: 'Street address',
          key: 'street_address'
        }, {
          title: 'Post code',
          key: 'post_code',
          disabled: !!_this.props.builder.infoQuestions.find(function (val) {
            return val === 'zip_code';
          })
        }, {
          title: 'City',
          key: 'city'
        }, {
          title: 'State',
          key: 'state',
          disabled: !!_this.props.builder.infoQuestions.find(function (val) {
            return val === 'province';
          })
        }, {
          title: 'Country',
          key: 'country'
        }, {
          title: 'Zip code',
          key: 'zip_code',
          disabled: !!_this.props.builder.infoQuestions.find(function (val) {
            return val === 'post_code';
          })
        }, {
          title: 'Province',
          key: 'province',
          disabled: !!_this.props.builder.infoQuestions.find(function (val) {
            return val === 'state';
          })
        }]
      }, {
        title: 'Demographic Questions',
        fields: [{
          title: 'Date of Birth',
          key: 'dob'
        }, {
          title: 'Marital status',
          key: 'marital_status'
        }, {
          title: 'Military status',
          key: 'military_status'
        }, {
          title: 'Gender',
          key: 'gender'
        }, {
          title: 'Relationship status',
          key: 'relationship_status'
        }]
      }, {
        title: 'Work Information',
        fields: [{
          title: 'Job Title',
          key: 'job_title'
        }, {
          title: 'Work email',
          key: 'work_email'
        }, {
          title: 'Work phone number',
          key: 'work_phone_number'
        }, {
          title: 'Company Name',
          key: 'company_name'
        }]
      }];
    });

    _defineProperty(_assertThisInitialized(_this), "renderInformationCheckboxes", function () {
      return _this.informationTypes().map(function (_ref, idx) {
        var title = _ref.title,
            fields = _ref.fields;
        return /*#__PURE__*/React.createElement("div", {
          key: idx
        }, /*#__PURE__*/React.createElement("p", {
          style: {
            marginTop: 12,
            marginBottom: 12,
            marginLeft: 0,
            marginRight: 0,
            fontWeight: '500'
          }
        }, title), /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, fields.map(function (field) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-xs-6",
            key: field.key
          }, /*#__PURE__*/React.createElement(Checkbox, {
            label: field.title,
            disabled: !!field.disabled,
            name: field.key,
            checked: _this.props.builder.infoQuestions.indexOf(field.key) !== -1,
            onCheck: function onCheck(e, checked) {
              var infoQuestions = _this.props.builder.infoQuestions;

              _this.props.changeField(['infoQuestions', checked ? infoQuestions.length : infoQuestions.indexOf(field.key)], checked ? field.key : undefined);
            }
          }));
        })));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePopoverClose", function () {
      _this.setState({
        anchorEl: null
      });

      _this.props.changeField('addCustomQuestionPopover', false);
    });

    _this.state = {};
    return _this;
  }

  _createClass(Questions, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("section", {
        style: {
          margin: '1rem'
        }
      }, this.props.validationErrors.length > 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 50
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "There are errors in this section.")), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("ul", null, this.props.validationErrors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", {
          style: {
            color: 'red'
          }
        }, e);
      })))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: 12,
          color: '#919191'
        }
      }, "You can customize the headline on the top of questions. (Optional)")), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Headline"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-10"
      }, this.props.builder && /*#__PURE__*/React.createElement(TextField, {
        hintText: "Sign up by providing your info below.",
        value: this.props.builder.questionsHeadline,
        fullWidth: true,
        onChange: function onChange(_ref2) {
          var target = _ref2.target;

          _this2.props.changeField('questionsHeadline', target.value);

          _this2.handlePopoverClose();
        }
      }))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: 12,
          color: '#919191'
        }
      }, "What information would you like to ask for?")), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, this.props.builder && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.renderInformationCheckboxes())), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: 12,
          marginBottom: 12,
          marginLeft: 0,
          marginRight: 0,
          fontWeight: '500'
        }
      }, "Custom Questions (Optional)"), /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: 12,
          color: '#919191',
          margin: 0
        }
      }, "Request additional information with custom form questions."), this.props.builder && this.props.builder.customQuestions && this.props.builder.customQuestions.length > 0 && this.props.builder.customQuestions.map(function (q, idx) {
        var component = null;

        switch (q.type) {
          case 'short_answer':
            component = /*#__PURE__*/React.createElement(ShortAnswerQuestion, {
              key: idx,
              handleRequestDelete: function handleRequestDelete() {
                _this2.props.changeField("customQuestions[".concat(idx, "]"), undefined);
              },
              onChange: function onChange(_ref3) {
                var target = _ref3.target;

                _this2.props.changeField("customQuestions[".concat(idx, "].question"), target.value);
              },
              question: q.question
            });
            break;

          case 'multiple_choice':
            component = /*#__PURE__*/React.createElement(MultipleChoiceQuestion, {
              key: idx,
              question: q.question,
              answers: q.answers,
              handleRequestDelete: function handleRequestDelete(chip, index) {
                _this2.props.changeField("customQuestions[".concat(idx, "].answers[").concat(index, "]"), undefined);
              },
              onRequestAdd: function onRequestAdd(value) {
                _this2.props.changeField("customQuestions[".concat(idx, "].answers[").concat(q.answers.length, "]"), value);
              },
              onChange: function onChange(_ref4) {
                var target = _ref4.target;

                _this2.props.changeField("customQuestions[".concat(idx, "].question"), target.value);
              },
              handleQuestionRequestDelete: function handleQuestionRequestDelete() {
                _this2.props.changeField("customQuestions[".concat(idx, "]"), undefined);
              }
            });
            break;

          /* case 'appointment_scheduling':
            component = (
              <AppointmentScheduling
                question={q.question}
                answers={q.answers}
                onChangeQuestion={({ target }) => {
                  this.props.setLeadFormCustomQuestion(this.props.organization.id, idx, target.value);
                }}
                onToggle={(e, checked) => {
                  this.props.setAppointmentConfirmationEnabled(this.props.organization.id, idx, checked);
                }}
                onChangeConfirmation={({ target }) => {
                  this.props.setAppointmentConfirmationText(this.props.organization.id, idx, target.value);
                }}
                handleRequestDelete={() => {
                  this.props.removeLeadFormCustomQuestion(this.props.organization.id, idx);
                }}
              />
            );
            break;*/

          default:
            component = null;
            break;
        }

        return component;
      }), this.props.builder && /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          height: 50,
          border: '1px dashed #dadcde',
          padding: '1rem',
          color: 'rgb(130, 130, 130)',
          cursor: 'pointer'
        },
        id: "addCustomQuestion",
        onClick: function onClick(e) {
          _this2.setState({
            anchorEl: e.currentTarget
          });

          _this2.props.changeField('addCustomQuestionPopover', !_this2.props.builder.addCustomQuestionPopover);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus",
        "aria-hidden": "true"
      }), " Add Custom Question"), /*#__PURE__*/React.createElement(Popover, {
        open: this.props.builder.addCustomQuestionPopover,
        anchorEl: this.state.anchorEl,
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'bottom'
        },
        targetOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        onRequestClose: this.handlePopoverClose
      }, /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-font",
          "aria-hidden": "true"
        }), " Short Answer"),
        onClick: function onClick() {
          _this2.props.changeField("customQuestions[".concat(_this2.props.builder.customQuestions.length, "]"), {
            type: 'short_answer',
            question: ''
          });

          _this2.handlePopoverClose();
        }
      }), /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-dot-circle-o",
          "aria-hidden": "true"
        }), " Multiple Choice"),
        onClick: function onClick() {
          _this2.props.changeField("customQuestions[".concat(_this2.props.builder.customQuestions.length, "]"), {
            type: 'multiple_choice',
            question: '',
            answers: []
          });

          _this2.handlePopoverClose();
        }
      })))));
    }
  }]);

  return Questions;
}(Component)) || _class);
export default Questions;